import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
  const jwtToken = localStorage.getItem(ACCESS_TOKEN);
  return {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + jwtToken,
  };
}

function getAccountDashboard({ payload } = {}) {
  return axiosClient({
    url: constants.api.analytics.getAccountDashboard,
    method: HTTP_METHODS.POST,
    headers: _constructHeader(),
    data: payload,
  });
}

function getAccountTokensUsageSummary(payload  = {}) {
  return axiosClient({
    url: constants.api.analytics.getAccountTokensUsageSummary,
    method: HTTP_METHODS.POST,
    headers: _constructHeader(),
    data: payload,
  });
}

const AnalyticsService = {
  getAccountDashboard,
  getAccountTokensUsageSummary,
};

export default AnalyticsService;
